<template>
<div class="tasks">
  <h4>Список заданий ({{ tasks.length }})</h4>

  <div class="header-menu">
    <button 
      type="button" 
      class="header-menu__btn" 
      @click="openPopup('AddTaskBlock', null)"
    >
      <i class="fas fa-plus"></i>
      Добавить задание
    </button>
  </div>

  <ul v-if="tasks.length" class="task__list items-list">
    <li v-for="(task, index) in tasks" :key="task.id" class="items-list__item">
      <div class="items-list__header">
        <div class="items-list__info">
          <span>{{ task.title }}</span>
          <span>{{ getLevelTitle(task.level) }}</span>
        </div>       

        <div class="header-menu">
          <button 
            type="button" class="header-menu__btn" 
            @click="openPopup('AddTaskBlock', task)"
          >
            <i class="far fa-edit"></i>
            Редактировать
          </button>

          <button 
            type="button" 
            class="header-menu__btn header-menu__btn--remove" 
            @click="removeTaskBlock(task.id, index)"
          >
            <i class="fas fa-trash-alt"></i>
            Удалить
          </button>
        </div>  
      </div>

      <div class="items-list__footer options">
        <button 
          type="button" class="header-menu__btn header-menu__btn--add" 
          @click="openPopup('AddTaskOption', { block: task, option: null })"
        >
          <i class="fas fa-plus"></i>
          Вариант
        </button>

        <ul class="options__list">
          <li class="options__item" v-for="(option, index) in task.tasks" :key="option.id">
            <span>Вариант {{ index + 1 }}</span>
            <div class="header-menu">
               <button 
                  type="button" class="header-menu__btn" 
                  @click="openPopup('AddTaskOption', { block: task, option })"
                >
                  <i class="far fa-edit"></i>
                </button>

                <button 
                  type="button" 
                  class="header-menu__btn header-menu__btn--remove" 
                  @click="removeTaskOption(option.id, index, task)"
                >
                  <i class="fas fa-trash-alt"></i>
                </button> 
            </div>
          </li>
        </ul>
      </div>
    </li>
  </ul>

  <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
    <template v-slot:content>
      <component 
        :is="popupContent" 
        :data="popupData" 
        @close-popup="popupIsOpened = false"  
        @add-task-block="addItem(tasks, $event)"
        @add-task-option="addItem(tasks, $event)"        
      ></component>
    </template>
  </Popup>
</div>
</template>

<script>
import { addItem } from '../../../other/methods/list_actions'
import AddTaskBlock from './AddTaskBlock.vue'
import AddTaskOption from './AddTaskOption.vue'
import { getLevelTitle } from './levels'
import { popup_mix } from '../../../mixins/popup_mix'
export default {
  inject: ['http'],
  components: { AddTaskBlock, AddTaskOption },
  mixins: [ popup_mix ],
  data() {
    return {
      tasks: []
    }
  },
  methods: {
    getLevelTitle,
    addItem,
    removeTaskBlock(id, index) {
      swal({
        title: 'Внимание!',
        text: `Удалить задание?`,
        icon: "warning",
        buttons: ['Отмена', 'Да'],
        dangerMode: true,
      })
      .then((choise) => {
        if (choise) {
          this.http.post('onDeleteMatriusBlock', { id }).then(() => {
            this.tasks.splice(index, 1)
            swal('Успешно!', 'Задание удалено', 'success')
          }) 
          .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
        } 
      })
    },
    removeTaskOption(id, index, task) {
      swal({
        title: 'Внимание!',
        text: `Удалить вариант?`,
        icon: "warning",
        buttons: ['Отмена', 'Да'],
        dangerMode: true,
      })
      .then((choise) => {
        if (choise) {
          this.http.post('onDeleteMatriusTask', { id }).then(() => {
            task.tasks.splice(index, 1)
            swal('Успешно!', 'Задание удалено', 'success')
          }) 
          .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
        } 
      })
    }
  },
  created() {
    this.http.post('onGetMatriusBlocks').then(res => {
      this.tasks = res.data
      console.log(this.tasks)
    })
    .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
  }
}
</script>

<style lang="scss" scoped>
.tasks {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.options {
  margin-top: 20px;
}

.options__list {
  margin-top: 10px;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
}
.options__item {
  display: flex;
  flex-direction: column;
  width: 90px;
  padding: 6px;
  border: 2px solid #1e87f0;
  border-radius: 8px;
  font-size: 13px;
  text-align: center;
  margin-right: 10px;
  margin-bottom: 10px;

  & .header-menu {
    margin-top: 5px;
  }
}
</style>